import React from "react";
import Context from "../../../Context";
import List from "../../Misc/List";
import FieldsList from "../../Misc/FieldsList";
import Sortings from "../../Misc/Sortings";
import Filters from "../../Misc/Filters";
import visualState from "../../../visualState";
import NoticeListItem from "./NoticeListItem";
import user from "../../../user";

import config from "./config";

let searchTimeout = null;

export default class NoticeList extends React.Component {
  static contextType = Context;
  static fieldsStorageName = "NoticeListFields";
  constructor(props) {
    super(props);

    this.vState = new visualState("NoticeList");

    let defaultFilter = this.filtersMakeDefault(this.props.mode);
    let showStateFilter = this.props.mode !== "completed";

    this.state = {
      pending: false,
      searchPending: false,
      search: [],
      customListKey: "",
      showStateFilter: showStateFilter,
      filters: {
        show: false,
        active: [],
        default: defaultFilter,
        all: [
          {
            id: "created",
            title: "По дате создания",
            kind: "range",
            active: false,
            value: [],
          },
        ],
      },
      fields: {
        all: [],
        active: [],
      },
      sortings: {
        all: [
          {
            id: "byLabelAsc",
            active: false,
            title: "По алфавиту",
            value: ["text ASC"],
          },
          {
            id: "byCreatedDesc",
            active: false,
            title: "По дате создания",
            value: ["created DESC"],
          },
        ],
        active: [],
      },
    };
  }
  componentDidMount() {
    this.loadInfo();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.mode !== this.props.mode) {
      let defaultFilter = this.filtersMakeDefault(this.props.mode);
      let showStateFilter = false;
      this.setState((state) => {
        let filters = this.filtersDeactivate(state.filters);
        filters.default = defaultFilter;
        filters.show = false;
        return { filters, showStateFilter };
      });
    }
  }

  filtersDeactivate(filters) {
    filters.active = [];
    if (Array.isArray(filters.all)) {
      filters.all.forEach((filter, index) => {
        filters.all[index].active = false;
        filters.all[index].activeVariants = [];
      });
    }
    return filters;
  }

  filtersMakeDefault = (mode) => {
    let defaultFilter = [];

    defaultFilter.push({
      field: "userid",
      compare: "EQL",
      value: user.id || 0,
    });

    if (mode === "archive") {
      defaultFilter.push({
        field: "status",
        valarr: [
          config.STATUS_APPROVED,
          config.STATUS_DECLINED,
          config.STATUS_VIEWED,
        ],
      });
    }

    if (mode === "interfere") {
      defaultFilter.push({
        field: "status",
        valarr: [config.STATUS_NEW],
      });
      defaultFilter.push({
        field: "category",
        valarr: [config.CATEGORY_INTERFERE],
      });
    }

    if (mode === "current") {
      defaultFilter.push({
        field: "status",
        valarr: [config.STATUS_NEW],
      });
    }

    return defaultFilter;
  };

  loadInfo = async () => {};

  toggleFilters = (v) => {
    this.setState((state) => {
      let filters = state.filters;
      filters.show = v;
      return { filters };
    });
  };

  handleFilters = (changedFilters) => {
    this.setState((state) => {
      let filters = state.filters;
      filters.active = changedFilters;
      return { filters };
    });
  };
  handleFields = (changedFields) => {
    localStorage.setItem(this.fieldsStorageName, JSON.stringify(changedFields));
    this.setState((state) => {
      let fields = state.fields;
      fields.active = changedFields;
      return { fields };
    });
  };
  handleSortings = (chnagedSortings) => {
    this.setState((state) => {
      let sortings = state.sortings;
      sortings.active = chnagedSortings;
      return { sortings };
    });
  };
  handleSearch = (searchValue) => {
    this.setState({ searchPending: true });
    window.clearTimeout(searchTimeout);
    searchTimeout = window.setTimeout(() => {
      let search = searchValue
        ? [
            {
              lstr: "(",
              field: "text",
              compare: "IKE",
              value: `%${searchValue}%`,
              rstr: ")",
            },
          ]
        : [];
      this.setState({ searchPending: false, search });
    }, 1500);
  };

  onFinish = () => {
    this.setState({ customListKey: this.context.key() });
    this.context.notifier.load("notice", false);
  };
  onNoticeAction = async (data) => {
    await this.context.api.q("/notice/set", {
      id: data.id,
      status: data.status,
    });
    this.onFinish();
  };

  onListLoadStart = () => {
    this.setState({ pending: true });
  };
  onListLoadEnd = () => {
    this.setState({ pending: false });
  };

  render() {
    let allFilters = this.state.filters.all.slice();
    if (!this.state.showStateFilter) {
      allFilters.forEach((filter, index) => {
        if (filter.id === "statecode") {
          allFilters.splice(index, 1);
        }
      });
    }

    let filters = (
      <div
        className={`${
          this.state.filters.show ? "d-flex" : "d-none"
        }  align-items-center justify-content-end mt-0 py-5 px-7 mb-2 border-bottom w-100 shadow-sm`}
      >
        <Filters
          key={JSON.stringify(allFilters)}
          changeFn={this.handleFilters}
          filters={allFilters}
        />
      </div>
    );

    return (
      <>
        <div className="card card-custom  ">
          <div className="card-header px-5 py-2">
            <div className="card-title w-100 mr-0 p-lg-0 py-5 d-block d-lg-flex align-items-center justify-content-between">
              <div className="text-nowrap d-inline-block mr-2">
                {this.state.searchPending ? (
                  <div className="spinner mr-10 d-inline-block"></div>
                ) : (
                  ""
                )}
                <input
                  className="form-control form-control-solid d-inline-block w-auto"
                  type="text"
                  placeholder="Поиск"
                  onChange={(e) => this.handleSearch(e.target.value)}
                />
              </div>

              <div>
                {false ? (
                  <FieldsList
                    changeFn={this.handleFields}
                    fields={this.state.fields.all}
                    activeFields={this.state.fields.active}
                  />
                ) : null}

                <button
                  className="btn btn-light mr-2"
                  onClick={() => this.toggleFilters(!this.state.filters.show)}
                >
                  <i
                    className={`fa fa-filter p-0 ${
                      this.state.filters.show ? "text-primary" : "text-muted"
                    }`}
                  ></i>
                </button>
                <Sortings
                  changeFn={this.handleSortings}
                  sortings={this.state.sortings.all}
                />
              </div>
            </div>
          </div>
          {filters}
          <div className="card-body px-5">
            <List
              listKey="NoticeList"
              key={this.state.customListKey}
              fulltext={JSON.stringify(this.state.search)}
              search={JSON.stringify(
                this.state.filters.active.concat(this.state.filters.default)
              )}
              sort={JSON.stringify(this.state.sortings.active)}
              fields={JSON.stringify(this.state.fields.active)}
              limit={20}
              keyField="id"
              path="/notice/list"
              row={this.state.viewGrid}
              onLoadStart={this.onListLoadStart}
              onLoadEnd={this.onListLoadEnd}
            >
              <NoticeListItem
                onNoticeAction={this.onNoticeAction}
                onFinish={this.onFinish}
              />
            </List>
          </div>
        </div>
      </>
    );
  }
}
